export default __webpack_public_path__ + "static/creativity-a44681bf5e2cf4e022179b803075637d.svg";